import * as React from 'react';

import Browser from 'bundles/widget-simulator/components/browser/Browser';

import 'css!./__styles__/Content';

const Content = () => {
  return (
    <div className="rc-Content flex-1">
      <div className="content-inner">
        <Browser />
      </div>
    </div>
  );
};

export default Content;
